import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import useUpSellsCarouselQuery from 'api/queries/useUpSellsCarouselQuery';
import CartProductCard from 'features/shop/cart/CartProductCard';
import Carousel from 'honeydew/Carousel';
import useGlobalStore from 'hooks/useGlobalStore';
import { capitalizeWords } from 'utils/globalUtils';

function UpSellsCarousel({ name, type }) {
    const navigate = useNavigate();
    const { setCartOpen } = useGlobalStore();

    const { data: carousel } = useUpSellsCarouselQuery({ type });
    const { dsSource, items } = carousel?.results ?? {};

    const navigateToPDP = ({ productId }) => {
        if (window.isNativeApp) {
            window.ReactNativeWebView?.postMessage(JSON.stringify({ navigate: 'PDP', pdpId: productId }));
        } else {
            setCartOpen(false);
            navigate(`/shop/product/${productId}`);
        }
    };

    if (!carousel) return null;

    const carouselTitle = type.split('_').join(' ');

    const carouselData = {
        id: type,
        name: name || capitalizeWords(carouselTitle),
        items,
        featured: false,
    };

    const carouselProductCards = items?.map((item) => (
        <div className="flex w-full items-center justify-center rounded-md bg-white p-10" key={item.id}>
            <CartProductCard
                onClick={() => navigateToPDP({ productId: item.id })}
                product={item}
                upSellsItem="cart_upsell"
                dsSource={dsSource}
            />
        </div>
    ));

    return (
        <Carousel carousel={carouselData} upSellsCarousel scrollOverride={1} slideOverride={1.08}>
            {carouselProductCards}
        </Carousel>
    );
}

UpSellsCarousel.propTypes = {
    name: PropTypes.string,
    type: PropTypes.string,
};

UpSellsCarousel.defaultProps = {
    name: '',
    type: 'top_sellers',
};

export default UpSellsCarousel;
